import { render } from "./Yuebao.vue?vue&type=template&id=2aadae13&scoped=true"
import script from "./Yuebao.vue?vue&type=script&lang=js"
export * from "./Yuebao.vue?vue&type=script&lang=js"

import "./Yuebao.vue?vue&type=style&index=0&id=2aadae13&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aadae13"]])

export default __exports__